/**
 * Форматирование чисел
 * @param number
 * @param decimals
 * @param dec_point
 * @param thousands_sep
 * @returns {string}
 */
window.number_format = function (number, decimals = 0, dec_point = '.', thousands_sep = ',') {
	let sign = number < 0 ? '-' : '';

	let s_number = Math.abs(parseInt(number = (+number || 0).toFixed(decimals))) + "";
	let len = s_number.length;
	let tchunk = len > 3 ? len % 3 : 0;

	let ch_first = (tchunk ? s_number.substr(0, tchunk) + thousands_sep : '');
	let ch_rest = s_number.substr(tchunk)
	.replace(/(\d\d\d)(?=\d)/g, '$1' + thousands_sep);
	let ch_last = decimals ?
		dec_point + (Math.abs(number) - s_number)
		.toFixed(decimals)
		.slice(2) : '';

	return sign + ch_first + ch_rest + ch_last;
};

/**
 *
 * @param n
 * @param forms
 * @returns {*}
 */
window.getWordForm = function (n, forms) {
	if (n > 0) {
		n = Math.abs(n) % 100;
		let n1 = n % 10;
		if (n > 10 && n < 20) return forms[2];
		if (n1 > 1 && n1 < 5) return forms[1];
		if (n1 === 1) return forms[0];
	}
	return forms[2];
};

/**
 *
 * @param value
 * @param decimals
 * @returns {string}
 */
window.output_numbers = function (value, decimals = 0) {
	let val = number_format(value, decimals, '.', ' ');

	if (decimals > 0) {
		let s = '0'.repeat(decimals);
		let re = new RegExp("\." + s + '$');
		val = val.replace(re, '');
	}

	return val;
};

/**
 *
 * @param n
 * @param forms
 * @returns {string}
 */
window.output_wordform = function (n, forms) {
	return n + ' ' + getWordForm(n, forms);
};

/**
 *
 * @param money
 * @param decimals
 * @returns {string}
 */
window.output_money = function (money, decimals = 0) {
	return output_numbers(money, decimals) + ' р';
};

/**
 *
 * @param money
 * @param decimals
 * @returns {string}
 */
window.output_roubles = function (money, decimals = 2) {
	return output_numbers(money, decimals) + ' ₽';
};

/**
 * Рандомная строка
 * @param length
 * @returns {string}
 */
window.str_random = function (length) {
	let result           = '';
	let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	let charactersLength = characters.length;
	for ( let i = 0; i < length; i++ ) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}

	return result;
};

/**
 * Консоль
 * @param type
 * @param arr
 * @returns {boolean}
 * @constructor
 */
window.VGLog = function (type, arr = []) {
	if (!type) return false;

	switch (type) {
		case 'error':
			arr.forEach(function (item) {
				console.error(item);
			});
			break;
		case 'debug':
			arr.forEach(function (item) {
				console.debug(item);
			});
			break;
		case 'success':
			if (arr.length) {
				arr.forEach(function (item) {
					console.log("%c" + item, "color: green;");
				});
			}
			break;
		default:
			console.log(type);
			break;
	}
};

/**
 * @param url
 * @param title
 * @param w
 * @param h
 * @returns {WindowProxy}
 */
window.popupwindow = function (url, title, w, h) {
	var left = (screen.width / 2) - (w / 2);
	var top = (screen.height / 2) - (h / 2);
	return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
};
